<div class="asociados-listado">
    <div class="panel">
        <div class="toolbar">
            <div class="toolbar-wide">
                <label class="form-label" for="aso-busqueda">Buscar</label>
                <div class="search-field">
                    <i class="bi bi-search" aria-hidden="true"></i>
                    <input id="aso-busqueda" type="search" class="form-control" data-testid="busqueda" autocomplete="off"
                        placeholder="Nombre, DNI/NIF, teléfono o correo" [formControl]="busqueda">
                </div>
            </div>
            <div>
                <label class="form-label" for="aso-asociacion">Asociación</label>
                <select id="aso-asociacion" class="form-select" data-testid="filtro-asociacion" [(ngModel)]="asociacion" (ngModelChange)="reiniciar()">
                    <option value="">Todas las asociaciones</option>
                    @for (a of asociaciones; track a.id) { <option [ngValue]="a.id">{{ a.nombre }}</option> }
                </select>
            </div>
            <div>
                <label class="form-label" for="aso-tamano">Por página</label>
                <select id="aso-tamano" class="form-select" data-testid="tamano-pagina" [(ngModel)]="pageSize" (ngModelChange)="reiniciar()">
                    @for (t of TAMANOS; track t) { <option [ngValue]="t">{{ t }}</option> }
                </select>
            </div>
        </div>
    </div>

    <div class="toolbar-summary">
        <p aria-live="polite" data-testid="resumen">
            @if (cargando) {
                Buscando…
            } @else if (resultado) {
                @if (total) { <strong>{{ total }}</strong> asociado(s) encontrado(s) · mostrando {{ desde }}–{{ hasta }} } @else { 0 asociados encontrados }
            }
        </p>
        @if (hayFiltros) {
            <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="limpiar" (click)="limpiarFiltros()"><i class="bi bi-x-circle" aria-hidden="true"></i>Limpiar filtros</button>
        }
    </div>

    @if (error) {
        <div class="state-panel state-panel--error mb-3" role="alert" data-testid="error">
            <i class="bi bi-wifi-off state-panel__icon" aria-hidden="true"></i>
            <p class="state-panel__text">{{ error }}</p>
            <button type="button" class="btn btn-outline-danger btn-sm" data-testid="reintentar" (click)="reintentar()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
        </div>
    }

    <div class="results-area">
        @if (cargando) {
            <div class="progress results-progress" role="progressbar" aria-label="Cargando" data-testid="cargando">
                <div class="progress-bar progress-bar-striped progress-bar-animated w-100"></div>
            </div>
        }
        <div class="cards-grid" [class.is-loading]="cargando" data-testid="tarjetas">
            @for (a of resultado?.asociados ?? []; track a.id) {
                <app-item
                    data-testid="tarjeta"
                    [type]="ItemType.ASOCIADOS"
                    [item]="a"
                    [soloIdentidad]="true"
                ></app-item>
            }
        </div>
        @if (!(resultado?.asociados?.length) && !cargando && !error) {
            <div class="state-panel" role="status" data-testid="sin-resultados">
                <i class="bi bi-person-x state-panel__icon" aria-hidden="true"></i>
                <p class="state-panel__title">No se han encontrado asociados@if (hayFiltros) { con esos criterios }.</p>
                @if (hayFiltros) { <p class="state-panel__text">Prueba con otra búsqueda o limpia los filtros.</p> }
            </div>
        }
    </div>

    @if (totalPaginas > 1) {
        <nav class="pager" aria-label="Paginación de asociados">
            <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="anterior" [disabled]="pagina <= 1 || cargando" (click)="irA(pagina - 1)"><i class="bi bi-chevron-left" aria-hidden="true"></i>Anterior</button>
            <span data-testid="pagina">Página {{ pagina }} de {{ totalPaginas }}</span>
            <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="siguiente" [disabled]="pagina >= totalPaginas || cargando" (click)="irA(pagina + 1)">Siguiente<i class="bi bi-chevron-right" aria-hidden="true"></i></button>
        </nav>
    }
</div>
